// Should stay in sync with EventFlags.mjs

export const EVENT_FLAGS = {
  UPCOMING_EVENT: 1,
  FIRST_APPRAISAL_FOR_UNITS: 2
};
